import React from 'react';
import PropTypes from 'prop-types';

import { MissingEventMessage } from './missingEventMessage';

export default function RedirectStepConfig({ step, widget, config = {} }) {
    return <MissingEventMessage config={config} />;
}

RedirectStepConfig.propTypes = {
    step: PropTypes.object,
    widget: PropTypes.object,
    config: PropTypes.object
};
